import React, { useState } from "react";
import FilterLayout from "../../../components/FilterLayout/FilterLayout";
import { Button, Input, Select } from "antd";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import {
  checkValidEngNumbers,
  convertParamsIdToNumber,
  onChangeProvince,
  showManuFactoringYearsByCarModel,
} from "../../../core/utils";

import { useHistory } from "react-router-dom";

export const FilterCar = (props) => {
  const {
    filters,
    setFilters,
    onChangeFilters,
    provinces,
    cities,
    setCities,
    carTypes,
    year_range,
    getUsers,
    brands,
    models,
    getCarsBrands,
    getCarsModels,
    getCars,
    getCarsReport,
    cars,
  } = props;
  const { Option } = Select;
  const [isVisible, setIsVisible] = useState(false);
  const history = useHistory();

  return (
    <FilterLayout
      onSearch={getCars}
      search={filters.search}
      setSearch={(value) => onChangeFilters({ search: value })}
      placeHolder="Search by car plate number, car name, VIN"
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      reportFilter={getCarsReport}
    >
      <FormWrapper>
        <Select
          className="border-black-8 input-size mb-10"
          value={convertParamsIdToNumber(filters.province_id)}
          defaultValue={"All Provinces"}
          onChange={(value) => {
            onChangeProvince(
              value,
              () =>
                onChangeFilters({
                  province_id: value,
                  city_id: null,
                  operator_id: null,
                }),
              setCities
            );
            getUsers(value, null);
          }}
        >
          <Option value={null}>All Provinces</Option>
          {provinces?.map((province) => {
            return <Option value={province.id}>{province.name}</Option>;
          })}
        </Select>
        <Select
          className="border-black-8 input-size mb-10"
          onChange={(value) => {
            onChangeFilters({ city_id: value, operator_id: null });
            getUsers(filters.province_id, value);
          }}
          value={convertParamsIdToNumber(filters.city_id)}
          disabled={!filters.province_id}
        >
          <Option value={null}>All Cities</Option>
          {cities.map((city) => {
            return <Option value={city.id}>{city.name}</Option>;
          })}
        </Select>
        <Select
          className="border-black-8 input-size mb-10"
          onChange={(value) => {
            onChangeFilters({ car_type: value, brand: null, car_id: null });
            getCarsBrands(value);
          }}
          value={filters.car_type}
          placeholder="Type"
        >
          <Option value={null}>All Car Types</Option>
          {carTypes.map((carType) => {
            return (
              <Option key={carType[0]} value={carType[0]}>
                {carType[1]}
              </Option>
            );
          })}
        </Select>
        <Select
          className="border-black-8 input-size mb-10"
          onChange={(value) => {
            onChangeFilters({ brand: value, car_id: null });
            getCarsModels(value);
          }}
          value={filters.brand}
          disabled={!filters.car_type}
        >
          <Option value={null}>All Brands</Option>
          {brands.map((brand) => {
            return (
              <Option key={brand.id} value={brand.id}>
                {brand.name}
              </Option>
            );
          })}
        </Select>
        <Select
          className="border-black-8 input-size mb-10"
          disabled={!filters.brand}
          onChange={(value) => {
            onChangeFilters({ car_id: value });
            getCarsModels(value);
          }}
          value={convertParamsIdToNumber(filters.car_id)}
        >
          <Option value={null}>All Models</Option>
          {models.map((model) => {
            return (
              <Option key={model.id} value={model.id}>
                {model.name}
              </Option>
            );
          })}
        </Select>
        <Select
          className="border-black-8 input-size mb-10"
          placeholder="Year"
          onChange={(value) => onChangeFilters({ year: value })}
          value={filters.year}
          disabled={!filters.car_id}
        >
          {showManuFactoringYearsByCarModel(
            models.find((model) => model.id === filters.car_id),
            year_range
          ).map((year, ydx) => {
            return (
              <Option key={ydx} value={year}>
                {year}
              </Option>
            );
          })}
        </Select>
        <Select
          className="border-black-8 input-size mb-10"
          onChange={(value) => {
            onChangeFilters({ usage: value });
          }}
          placeholder="Car Usage"
          value={filters.usage}
        >
          <Option value={null}>Car Usage</Option>
          {cars?.extra &&
            cars.extra.usage.map((use_car) => {
              return (
                <Option key={use_car.id} value={use_car[0]}>
                  {use_car[1]}
                </Option>
              );
            })}
        </Select>
        <Input
          type="text"
          placeholder="Car Capacity"
          className="border-black-8 input-size mb-10"
          onKeyDown={checkValidEngNumbers}
          onChange={(e) => onChangeFilters({ capacity: e.target.value })}
          value={filters.capacity}
        />
        <Select
          className="border-black-8 input-size mb-10"
          onChange={(value) => onChangeFilters({ capacity_unit: value })}
          placeholder="Capacity Unit"
          value={filters.capacity_unit}
        >
          <Option value={null}>Capacity Unit</Option>
          {cars?.extra &&
            cars.extra.capacity_unit.map((capacity_unit) => {
              return (
                <Option key={capacity_unit[0]} value={capacity_unit[0]}>
                  {capacity_unit[1]}
                </Option>
              );
            })}
        </Select>
        <div />
        <Button
          className="button-secondary input-size mb-10"
          onClick={() => {
            getCars();
            setIsVisible(false);
          }}
        >
          Filter
        </Button>

        <Button
          className="button-red input-size sm:w-100 "
          onClick={() => {
            history.push(window.location.pathname);
            setIsVisible(false);
            setFilters({
              province_id: null,
              city_id: null,
              car_type: null,
              brand: null,
              car_id: null,
              search: "",
              usage: null,
              capacity: "",
              capacity_unit: null,
            });
            setTimeout(() => {
              getCars(1, true);
            }, 100);
          }}
        >
          Clear Filters
        </Button>
      </FormWrapper>
    </FilterLayout>
  );
};
